import React from "react";

const BlockLoader = (props) => {
    return(
        <div className="block-loader" style={{minHeight:props.height}}>
            <img src='../../assets/images/loader2.gif' alt="Loader"/>
        </div>
    );
}

export default BlockLoader;